<template>
  <div :class="titleType=='base'? 'topHeader topBaseHeader' :'topHeader'">
      <span class="leftT">{{dayInfo.time}}</span>
      <span class="nameT">{{ titUrl }}</span>
      <!-- <img :src="titUrl" alt=""> -->
      <div class="rightT">
        <span class="span1">{{dayInfo.area}} </span>
        <span>{{dayInfo.weather}}</span>
      </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance, nextTick,toRefs,onMounted } from "vue";
import * as date from "../../../js/date"
export default {
  props: {
      titUrl:{
        type:String,
        default:""
      },
      titleType:{
          type:String,
          default:""
      }
  },
  setup(props) {
    //   console.log(date.sloarToLunar(),date.getjq(),date.getWeek(),date.getDay(),'tianqi')
      const { proxy } = getCurrentInstance();
      const titUrl = props.titUrl;
      const titleType = props.titleType
      const dayInfo = ref({
          time:'',
          area:'',
          weather:''
      })
      dayInfo.value.time = date.getDay()+' ' +date.getWeek()+' '+'农历'+date.sloarToLunar().lunarMonth+'月'+date.sloarToLunar().lunarDay ;
      const getWeather = ()=>{
          proxy.$request({
              url:"N_GETWEATHER",
              method: "post",
              data:{
                  keyStr:'370700'
              },
          }).then((res)=>{
              if(res.data.code=='000'){
                    let data = res.data.result;
                    if(data.result){
                        dayInfo.value.area = data.result.location.province+data.result.location.city
                        if(data.result.forecasts.length>0){
                            let wea = data.result.forecasts[0];
                            dayInfo.value.weather = wea.text_day+'  '+wea.low+'-'+wea.high+'℃'
                        }
                    }
                }else{
                  proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                      confirmButtonText: '确定',
                  });
              }
          }).catch((err)=>{
              console.log(err)
          })
      }
      getWeather()
      return{
          titUrl,
          titleType,
          dayInfo
      }
  },
}
</script>
<style lang="less" scoped>
.topHeader{
  padding-top: 2.778vh !important;
  position: relative;
  height: 12.222vh;
  text-align: center;
  background: url(../../../images/topTit_icon.png) 0 0 no-repeat;
  background-size: 100% 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  .leftT,.rightT{
      position: absolute;
      font-size: 1vw;
      color: #2fbddf;
  }
  .leftT{
      left: 1vw;
  }
  .rightT{  
      right: 1vw;
      .span1{
        text-decoration-line: underline;
        margin-right: 1vw;
        font-size: 1.2vw;
      }
  }
  .nameT{
    color:#fff;
    font-size:1.8vw;
    font-weight: bold;
    background: -webkit-linear-gradient(#fff, #34D2F7); /* Chrome, Safari等 */
    background: linear-gradient(#ffffff, #34D2F7); /* 标准语法 */
    -webkit-background-clip: text; /* Chrome, Safari等 */
    background-clip: text;
    -webkit-text-fill-color: transparent; /* Chrome, Safari等 */
    color: transparent; /* 兼容其他浏览器 */

  }

  .rightT{
      right: 1vw;
  }
}
.topBaseHeader{
  background: url(../../../images/topTit_base_icon.png) 0 0 no-repeat;
  background-size: 100% 100%;
}
</style>
